import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-z-add-on-boarding',
  templateUrl: './z-add-on-boarding.component.html',
  styleUrls: ['./z-add-on-boarding.component.scss']
})
export class ZAddOnBoardingComponent implements OnInit {
formData: any = {
  title: '',
  description: '',
  image: null

};
   public arrCoupons: any[] = [];

    public currentLang : string
errors: any = {}; // store validation errors

  
  constructor(
    private router: Router,
    private apisService: ApisService,
    private toastr: ToastrService
  ) {}

    ngOnInit(): void {
                this.currentLang = localStorage.getItem('currentLang')


                  this.apisService.users().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })


    }
// onFileSelected(event: any) {
//   const file: File = event.target.files[0];
//   this.formData.image = file.name;
// }

onFileSelected(event: any) {
  const file = event.target.files[0];

  if (file) {
    this.formData.image = file;

    // remove image error once user selects a new file
    if (this.errors?.image) {
      delete this.errors.image;
    }
  }
}


    cancel(): void {
      this.router.navigate(['/z-on-boarding']);
    }
  
    getTranslation(translations: any[], locale: string) {
      return translations.find(translation => translation.locale === locale) || {};
    }


    
    /*----------  Submitting the form  ----------*/
    
    /*----------  Submitting the form  ----------*/
onSubmit() {
  this.errors = {}; // reset previous errors

  const formData = new FormData();
  formData.append('title', this.formData.title);
  formData.append('description', this.formData.description);

  if (this.formData.image) {
    formData.append('image', this.formData.image);
  }

  this.apisService.addOnBoarding(formData).subscribe({
    next: () => {
      this.toastr.success(
        this.currentLang === 'ar'
          ? 'تمت الإضافة بنجاح'
          : 'Added successfully'
      );

      this.router.navigate(['/z-on-boarding']);
    },

    error: (err) => {
      if (err.error?.errors) {
        this.errors = err.error.errors; // backend validation errors
      } else {
        this.toastr.error(
          this.currentLang === 'ar'
            ? 'حدث خطأ أثناء الإضافة'
            : 'Error adding'
        );
      }
    }
  });
}

}